<template>
    <div>
        <img :src="src" alt="" class="img-fluid">
    </div>
</template>
<script>
export default {
    name: 'link',
    data() {
        return {
            id: this.$route.params.id || '',
        };
    },
    computed: {
        src() {
            return `/img/pay/${this.id}.jpg`;
        }
    }
};
</script>